import { Flex, Spinner } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import {
  ContractStatusDto,
  SavedReportSystemKeyDto,
  type SavedReportDto,
  useListSavedReportsQuery,
} from "../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../common/auth/useLoggedInWithOrgContextState";
import { savedReportLink } from "../../../common/saved-reports/savedReportLists";
import { base64Encode } from "../../../common/utils/base64";
import { urls } from "../../../urls";

export const ActiveContractsRedirect = () => {
  const { t } = useTranslation();
  const { selectedOrg } = useLoggedInWithOrgContextState();
  const { data, isLoading, isError } = useListSavedReportsQuery({ organizationId: selectedOrg.id });

  if (isLoading) {
    return (
      <Flex w="full" h="60vh" alignItems="center" justifyContent="center">
        <Spinner size="xl" color="smPrimary" label={String(t("Loading"))} />
      </Flex>
    );
  }

  const report = isError ? undefined : data?.reports.find(isActiveContractsReport);
  return <Navigate to={report ? savedReportLink(report) : activeContractsFilterLink()} replace />;
};

const isActiveContractsReport = (report: SavedReportDto) =>
  report.systemKey === SavedReportSystemKeyDto.ActiveContracts;

const activeContractsFilterLink = () => {
  const params = new URLSearchParams({ q: base64Encode(JSON.stringify({ statuses: [ContractStatusDto.Active] })) });
  return `${urls.app.contracts.viewAll}?${params.toString()}`;
};
